import { render, staticRenderFns } from "./HtmlModal.vue?vue&type=template&id=672fe977"
import script from "./HtmlModal.vue?vue&type=script&lang=ts"
export * from "./HtmlModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports